const getMasterCourseKey = ({ id, version }) => `${id}/${version}`;

export default getMasterCourseKey;



// WEBPACK FOOTER //
// ./app/components/linked-course-modal/helpers.js